// @flow
import React, { Component, Fragment } from "react";

import { StyledTabs, AppHeader } from "imagus-components";
import FaceSearchTemplate from "./FaceSearchTemplate";
import FaceVerify from "./FaceVerify";

const initalHelp =
  "Use this page to do face detections against faces in your database. " +
  "NOTE: You MUST have faces enroled in the database in order for system to detect faces. " +
  "To enrol faces, go to the Person function and follow the instructions for creating a new person. Make sure to add at least one face to the person.";

type FaceTemplateStatesType = {
  helpText: string
};

class FaceTemplate extends Component<*, FaceTemplateStatesType> {
  constructor(props) {
    super(props);
    this.state = {
      helpText: initalHelp
    };
  }

  render(): * {
    const tabs = [
      { label: "Detection", component: <FaceSearchTemplate /> },
      { label: "Verification", component: <FaceVerify /> }
    ];

    return (
      <Fragment>
        <AppHeader title="Face Recognition" content={this.state.helpText} />
        <StyledTabs tabs={tabs} />
      </Fragment>
    );
  }
}

export default FaceTemplate;
